import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import Card from '../components/Card';
import Button from '../components/Button';

const NotFound = () => {
  return (
    <Layout 
      title="Page Not Found" 
      showHeader={true}
      showFooter={true}
    >
      <div className="max-w-lg mx-auto text-center py-12">
        <Card>
          <div className="py-8">
            <h1 className="text-6xl font-bold text-primary-500 mb-4">404</h1>
            <h2 className="text-2xl font-semibold mb-4">Page Not Found</h2>
            <p className="text-gray-600 mb-8">
              The page you are looking for doesn't exist or has been moved.
            </p>
            <div className="flex justify-center">
              <Link to="/">
                <Button>
                  Return to Home
                </Button>
              </Link>
            </div>
          </div>
        </Card>
        
        <div className="mt-8">
          <p className="text-gray-500 text-sm">
            If you believe this is an error, please contact support.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound; 